export function formatGNF(amount) {
  if (typeof amount !== "number") amount = Number(amount || 0);
  return new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(amount) + " GNF";
}

export function imgUrl(src) {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  // Legacy local paths (/api/static/images/foo.png) are auto-redirected to Azure Blob
  // after the Feb 2026 migration. Keeps existing pages working without editing every ref.
  const LEGACY_LOCAL = "/api/static/images/";
  const AZURE_SEED = "https://neldaari.blob.core.windows.net/neldaari-image/seed/";
  if (src.startsWith(LEGACY_LOCAL)) return AZURE_SEED + src.slice(LEGACY_LOCAL.length);
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return base.replace(/\/$/, "") + src;
}

export const STATUS_LABEL = {
  received: "Reçue",
  preparing: "En préparation",
  ready: "Prête pour livraison",
  delivering: "En livraison",
  delivered: "Livrée",
  cancelled: "Annulée",
  cancelled_in_delivery: "Annulée en cours de livraison",
};

export const STATUS_COLOR = {
  received: "#F4C430",
  preparing: "#F4C430",
  ready: "#E67E22",
  delivering: "#E32636",
  delivered: "#009E60",
  cancelled: "#4A4A4A",
  cancelled_in_delivery: "#B3261E",
};

export const PAYMENT_LABEL = {
  cash: "Paiement à la livraison",
  orange_money: "Orange Money",
  mtn_money: "MTN Mobile Money",
  card: "Carte bancaire",
  paypal: "PayPal / Carte internationale",
};

// Global mapping of payout operator codes → human labels
export const OPERATOR_LABELS = {
  orange_momo: "Orange Money",
  orange_money: "Orange Money",
  mtn_momo: "MTN MoMo",
  mtn_money: "MTN MoMo",
};

export function operatorLabel(op) {
  return OPERATOR_LABELS[(op || "").toLowerCase()] || op || "Mobile Money";
}

// Short unique tag to disambiguate homonym partners (ex: "Mamadou Bah #A47C")
export function shortTag(id) {
  return id ? "#" + String(id).slice(-4).toUpperCase() : "";
}
